import { render, staticRenderFns } from "./OrderDepositWait.vue?vue&type=template&id=7f3e5c87&"
import script from "./OrderDepositWait.vue?vue&type=script&lang=ts&"
export * from "./OrderDepositWait.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports